import { StandardEvents } from '@shopify/events';
const saved = new Map();
class KitRushPersonalization extends HTMLElement {
  connectedCallback() {
    this.abort = new AbortController();
    this.form = this.closest('form');
    if (!this.form) return;
    this.fieldset = this.querySelector('fieldset');
    this.inputs = [...this.querySelectorAll('input')];
    this.ids = new Set((this.dataset.personalizedIds || '').split(/\s+/));
    const prior = saved.get(this.dataset.productId) || [];
    this.inputs.forEach((input, i) => { input.value = prior[i] || ''; });
    const signal = this.abort.signal;
    document.addEventListener(StandardEvents.productSelect, event => {
      const source = event.target?.closest('product-card, product-information');
      if (source && !source.contains(this)) return;
      if (!event.promise) return;
      this.pending = true;
      Promise.resolve(event.promise).catch(() => {}).finally(() => {
        this.pending = false;
        requestAnimationFrame(() => { if (this.isConnected) this.sync(); });
      });
    }, { signal });
    this.form.addEventListener('change', () => this.sync(), { signal });
    this.addEventListener('input', () => {
      this.inputs.forEach(input => input.setCustomValidity(''));
      saved.set(this.dataset.productId, this.inputs.map(input => input.value));
    }, { signal });
    this.form.addEventListener('submit', event => {
      if (this.pending || !this.prepare()) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, { capture: true, signal });
    this.sync();
  }
  sync(variantId) {
    const id = String(variantId || this.form.querySelector('input[name="id"]')?.value || '');
    this.active = this.ids.has(id);
    this.fieldset.hidden = !this.active;
    this.inputs.forEach(input => { input.disabled = !this.active; });
  }
  prepare(variantId) {
    this.sync(variantId);
    this.inputs.forEach(input => input.setCustomValidity(''));
    if (!this.active) return true;
    this.inputs.forEach(input => { input.value = input.value.trim(); });
    const [name, number] = this.inputs;
    let invalid;
    if (!name.value && !number.value) {
      invalid = name;
      name.setCustomValidity(this.dataset.error);
    } else if (number.value && !/^[0-9]{1,3}$/.test(number.value)) {
      invalid = number;
      number.setCustomValidity(this.dataset.numberError);
    } else if (name.value.length > 20) {
      invalid = name;
      name.setCustomValidity(this.dataset.error);
    }
    if (invalid || !this.inputs.every(input => input.checkValidity())) {
      const target = invalid || this.inputs.find(input => !input.checkValidity());
      target.reportValidity();
      target.focus();
      return false;
    }
    saved.set(this.dataset.productId, this.inputs.map(input => input.value));
    return true;
  }
  disconnectedCallback() { this.abort?.abort(); }
}
if (!customElements.get('kitrush-personalization')) customElements.define('kitrush-personalization', KitRushPersonalization);

let cartRefresh = 0;
document.addEventListener(StandardEvents.cartLinesUpdate, async event => {
  const generation = ++cartRefresh;
  try {
    await event.promise;
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) return;
    const cart = await response.json();
    if (generation !== cartRefresh) return;
    document.querySelectorAll('.kr-cart-count').forEach(badge => { badge.textContent = String(cart.item_count); });
  } catch { /* Keep the server-rendered count if a request fails. */ }
});
